import React, { FC, ReactNode, useState } from 'react';
import { SidebarContext } from 'src/providers/sidebar/context';

export const SidebarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
};
